import axios from "axios"
export function getAllUsers(token, page, pageSize) {
    return axios.get(process.env.REACT_APP_API_URL + `/getAllUsers?page=${page}&pageSize=${pageSize}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}